import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoBlockComponent, InfoBlockData } from './info-block.component';
import { GroupedInfoBlocks, InfoBlock } from 'apps/design4circularity/src/app/models';

@Component({
  selector: 'ca-grouped-info-blocks',
  imports: [CommonModule, InfoBlockComponent],
  template: `
  @if (data){
    <div class="info-block-group grouped">

    <ca-info-block [data]="data.content[0]"></ca-info-block>
    <div class="group-right">
      @for (infoBlock of data.content; track $index) {
        @if ($index > 0) {
          <ca-info-block [data]="infoBlock"></ca-info-block>
        }
      }
    </div>

    </div>}
  `,
})
export class GroupedInfoBlocksComponent {
  @Input() data?: GroupedInfoBlocks;
}

export interface GroupedInfoBlocksData {
  content: Omit<InfoBlock, 'type'>[];
  cssClass: null | string;
}
